export const SET_CURRENT_USER = 'state/auth/SET_CURRENT_USER';
export const UNSET_CURRENT_USER = 'state/auth/UNSET_CURRENT_USER';
export const SET_USERS = 'state/auth/SET_USERS';
